import { getAuthCode } from "./getAuthCode";
export const updateRole = async(role) => {
    try {
      const authCode = await getAuthCode()
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/updateRole", {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({auth_code:authCode,role:role}),
      });
      const result = await response.json();
    } catch (error) {
      console.log(error);
    }
}